<div class="histogram">
  <div style="position: relative" [ngStyle]="{ height: labelRotation !== 0 ? '30vh' : '21vh' }">
    <svg style="min-width: 500px" [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewBox">
      <g [attr.transform]="'translate(' + marginLeft + ',' + marginTop + ')'">
        <g
          #histogramContainer
          [ngStyle]="isInteractive ? { transform: 'translate(0px, 50px)' } : { transform: 'translate(0px, 0px)' }"></g>
        <g *ngIf="isInteractive">
          <text
            id="valuesSelectedCount"
            [attr.x]="(startX + endX) / 2"
            [attr.y]="0"
            dy=".35em"
            text-anchor="middle"
            class="values-count-text">
            {{ initialSelectedValueNames.length + ' values' }}
          </text>
          <ng-container *ngIf="interactType === 'range selector'">
            <g gpf-histogram-range-selector-line [width]="2" [(x)]="startX"></g>
            <g gpf-histogram-range-selector-line [width]="2" [(x)]="endX"></g>
          </ng-container>
        </g>

        <g *ngIf="!isInteractive && singleScoreValueIsValid()">
          <!-- eslint-disable-next-line prettier/prettier -->
          <text [attr.x]="scaleXAxis(singleScoreValue)" [attr.y]="-10" class="small" text-anchor="middle">{{ singleScoreValue }}</text>
          <line
            *ngIf="!isInteractive && singleScoreValueIsValid()"
            class="single-score-marker"
            style="stroke: rgb(255, 0, 0); stroke-width: 2"
            [attr.x1]="scaleXAxis(singleScoreValue)"
            [attr.y1]="scaleYAxis(1)"
            [attr.x2]="scaleXAxis(singleScoreValue)"
            [attr.y2]="-5" />
        </g>
      </g>
    </svg>

    <div *ngIf="histogram.smallValuesDesc && histogram.largeValuesDesc" id="values-description">
      <span>{{ histogram.smallValuesDesc }}</span>
      <span>{{ histogram.largeValuesDesc }}</span>
    </div>
  </div>
</div>
